module.exports = __webpack_public_path__ + "img/logo-def.f5aad50c.png";